import z from "zod";
import {
  environmentsId,
  localeEnum,
  projectsId,
  templateContentsId,
  templatesId,
  templatesInitializer,
} from "../../db_gen";
import { TEMPLATE_TYPES } from "../../enums";
import { zodName, zodSlug } from "../../utils";

const templateCreateSchema = z.object({
  name: zodName(),
  description: templatesInitializer.shape.description,
  type: z.enum(TEMPLATE_TYPES),
  locales: z.array(localeEnum),
});

export type TemplateCreateSchema = z.infer<typeof templateCreateSchema>;
export type TemplateFormSchema = Omit<TemplateCreateSchema, "type">;

export default {
  getAllWithUserDrafts: z.object({
    projectId: projectsId,
    environmentId: environmentsId.optional(),
  }),
  getDraft: z.object({
    templateSlug: zodSlug(),
    projectId: projectsId,
  }),
  getPublishedTemplate: z.object({
    projectId: projectsId,
    environmentSlug: zodSlug(),
    templateSlug: zodSlug(),
  }),
  create: z.object({
    projectId: projectsId,
    data: templateCreateSchema,
  }),
  update: z.object({
    templateId: templatesId,
    data: templateCreateSchema.omit({ type: true }),
  }),
  delete: z.object({
    templateId: templatesId,
  }),
  publish: z.object({
    draftId: templateContentsId,
    changeType: z.enum(["minor", "patch"]),
    environmentIds: z.array(environmentsId),
  }),
  syncEnvironmentVersions: z.object({
    templateId: templatesId,
    activeEnvironmentContents: z.array(
      z.object({
        envId: environmentsId,
        contentId: templateContentsId,
      }),
    ),
  }),
};
